import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-status',
  imports: [MatCardModule],
  templateUrl: './status.component.html',
  styles: ``,
})
export class StatusComponent {

}
